import { AfterViewInit, Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FileConfig } from 'classes-lib';
import { DocumentTypePickerComponent, DocumentTypeService, IDocumentType } from 'document-type-picker-lib';
import { Namespace } from 'enums-lib';
import { Subscription } from 'rxjs';
import { SharedServiceProviderServiceFactory } from 'shared-service-provider-lib';

@Component({
  selector: 'app-file-type-restrictions',
  templateUrl: './file-type-restrictions.component.html',
  styleUrl: '../attachment-restrictions.component.scss',
  standalone: false,
})
export class FileTypeRestrictionsComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() fileSection: any;
  @Input() namespace: string;
  @Input() valid: boolean;
  @Input() outputFileType: string;
  @Input() documentTypes: IDocumentType[] = [];
  @Input() expandUp = false;
  @Input() set entityTypes(entityTypes: string[]) {
    this._entityTypes = entityTypes;
    if (this.initialised) {
      this.clearDocumentTypeIds();
    }
  }

  @ViewChild('typePicker')
  attachmentDocumentTypePicker: DocumentTypePickerComponent;

  _entityTypes: string[];
  loadingDocumentTemplates = 'Loading...';
  disabled = false;

  documentTypePickerHeight = '306px';
  restrictedFileType: string;

  private initialised = false;
  private attachmentDocumentTypePickerSubscription: Subscription;

  constructor(private documentTypeService: DocumentTypeService, private sharedServiceProvider: SharedServiceProviderServiceFactory) {}

  ngOnInit(): void {
    this.restrictedFileType = this.sharedServiceProvider.getServiceProviderService(this.namespace).getTerminologyService().fileType;
    if (this.namespace === Namespace.invenias) {
      this.documentTypePickerHeight = '246px';
    }
  }

  ngOnDestroy(): void {
    this.attachmentDocumentTypePickerSubscription?.unsubscribe();
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.loadDocumentTypeFilters();
      this.fileSection.updateValueAndValidity();
    });
  }

  onSelected(documentType: IDocumentType | undefined): void {
    if (documentType?.id) {
      if (!this.documentTypes.find((dt) => dt.id === documentType.id)) {
        this.documentTypes.push(documentType);
        this.documentTypes.sort((a, b) => a.label.localeCompare(b.label));
        this.updateConfigTypeIds();
        this.attachmentDocumentTypePicker.removeItem(documentType.id);
      }
    }
  }

  onRemove(documentType: IDocumentType): void {
    this.documentTypes = this.documentTypes.filter((dt) => dt.id !== documentType.id);
    this.documentTypes.sort((a, b) => a.label.localeCompare(b.label));
    this.updateConfigTypeIds();
    this.attachmentDocumentTypePicker.addItem(documentType);
  }

  private loadDocumentTypeFilters(): void {
    this.disabled = true;
    if (!this.config?.filters?.documentTypeId?.length) {
      this.loadingDocumentTemplates = undefined;
      this.initialised = true;
      this.disabled = false;
      return;
    }

    this.documentTypeService.getDocumentTypes(this.namespace, this._entityTypes).subscribe({
      next: (documentTypes) => {
        this.loadedDocumentTypeFilters(documentTypes);
      },
      error: (error) => {
        console.error('Failed to load document types.', error);
        this.loadingDocumentTemplates = 'Failed to load document types.';
      },
    });
  }

  private loadedDocumentTypeFilters(documentTypes) {
    this.disabled = false;
    this.documentTypes = documentTypes.filter((dt) => this.config.filters.documentTypeId.find((fdtId: string) => dt.id === fdtId));
    this.loadingDocumentTemplates = undefined;
    this.initialised = true;
    this.attachmentDocumentTypePickerSubscription = this.attachmentDocumentTypePicker.observeReady().subscribe({
      next: (_) => {
        this.documentTypes.forEach((dt) => this.attachmentDocumentTypePicker.removeItem(dt.id));
      },
    });
  }

  private clearDocumentTypeIds() {
    this.documentTypes = [];
    this.updateConfigTypeIds();
  }

  private updateConfigTypeIds(): void {
    this.config.filters.documentTypeId = this.documentTypes.map((dt) => dt.id);
    this.fileSection.get('config').setValue(this.config, { emitEvent: false });
    this.fileSection.markAsDirty();
    this.fileSection.updateValueAndValidity();
  }

  get config(): FileConfig {
    return this.fileSection.get('config').value as FileConfig;
  }
}
